import { getChannelContextCode } from 'helpers/Utility';
import { setError, setHomePath } from 'store/actions/auth';

/**
 * to handle error fetch path options
 * @param {*} dispatch
 * @param {*} err
 * @param {*} path
 * @returns
 */
export const handleFetchOptionsError = (dispatch, err, path) => {
  if (path !== '/LNPS') dispatch(setHomePath('/continue-apply'));

  if (err.toString().includes('Network Error')) {
    return dispatch(setError('connection'));
  }

  if (
    ['105265', '1003'].includes(getChannelContextCode(err, 'channel-context'))
  ) {
    return dispatch(setError('error_cocd'));
  }

  dispatch(setError('system'));
};
